/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, replacePXinStringWithEM} from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
export default theme =>({
    toaster: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        width: pxToEm(400),
        borderRadius: pxToEm(6),
        fontSize: pxToEm(16),
        fontWeight: 600,
        margin: replacePXinStringWithEM(`0px 5px`),
        padding: `${pxToEm(30)} ${pxToEm(16)}`,
        position: 'relative',

        // animation
        animationDelay: '0s',
        animationDuration: '.15s',
        animationFillMode: 'forwards',

        // ----- alignment ----- //
        '&.align-top-left': {
            boxShadow: theme.boxShadow.small,
            marginTop: pxToEm(5),
            animationName: 'slideInDown',
            justifySelf: 'flex-start',
            alignSelf: 'flex-start'
        },
        '&.align-top-right': {
            boxShadow: theme.boxShadow.small,
            marginTop: pxToEm(5),
            animationName: 'slideInDown',
            justifySelf: 'flex-end',
            alignSelf: 'flex-end'
        },
        '&.align-bottom-left': {
            boxShadow: theme.boxShadow.smallTop,
            marginBottom: pxToEm(5),
            animationName: 'slideInUp',
            justifySelf: 'flex-start',
            alignSelf: 'flex-start'
        },
        '&.align-bottom-right': {
            boxShadow: theme.boxShadow.smallTop,
            marginBottom: pxToEm(5),
            animationName: 'slideInUp',
            justifySelf: 'flex-end',
            alignSelf: 'flex-end'
        },

        // ----- variants ----- //
        '&.variant-primary': {
            background: theme.color.primary.medium.swatch,
            color: theme.color.primary.medium.contrast
        },
        '&.variant-attention': {
            background: theme.color.attention.medium.swatch,
            color: theme.color.attention.medium.contrast
        },

        // ----- close button ----- //
        '& .icon.name-times': {
            cursor: 'pointer'
        },

        // ---- custom fontsize for massive request demo message ----- //
        '& .pageview':{
            fontSize: pxToEm(12)
        }
    }
});